import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Card, Carousel, Badge, notification, Row, Col } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquare } from "@fortawesome/pro-solid-svg-icons";

import { GET } from "../../../providers/useAxiosQuery";
import carouselImgLgu from "../../../assets/img/lgu_image.png";
import carouselImgOrgon from "../../../assets/img/orgon_image.png";
import {
	checkPermissions,
	deleteFile,
	readFile,
	useRequestPublicStoragePermissions,
	setFileStorage,
} from "../../../providers/useCapacitorStorage";
import SurveyList from "./SurveyList";
import { faSpinnerScale } from "@fortawesome/pro-regular-svg-icons";

export default function PageDashboard() {
	const navigate = useNavigate();
	const location = useLocation();

	const host = window.location.origin;

	console.log("host: ", host);

	useRequestPublicStoragePermissions();

	const [formList, setFormList] = useState([]);
	const [surveyPendingList, setSurveyPendingList] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	const { refetch: refetchFormList } = GET(
		`api/form?from=SurveyMobile`,
		"form_list",
		async (res) => {
			if (res && res.data) {
				let data = res.data;

				let datasync = document.getElementById("datasync");
				if (datasync) {
					datasync.classList.remove("hide");
					console.log("datasync");
				}

				let dataSurveyFiltered = data.filter(
					(f) => f.form_question_categories.length > 0,
				);

				setFormList(dataSurveyFiltered);

				let resCheckPermissions = await checkPermissions();

				if (
					resCheckPermissions &&
					resCheckPermissions.publicStorage === "granted"
				) {
					let resSetFileStorage = await setFileStorage(
						"fsuu_dsac_survey_sk",
						"form_list",
						dataSurveyFiltered,
					);

					if (resSetFileStorage && resSetFileStorage.uri) {
						setTimeout(() => {
							if (datasync) {
								datasync.classList.add("hide");
							}
						}, 1000);
					} else {
						let resDeleteFile = await deleteFile(
							"fsuu_dsac_survey_sk/form_list.txt",
						);

						if (resDeleteFile) {
							notification.error({
								message: "Delete Survey List",
								description: JSON.stringify(resDeleteFile),
							});
						} else {
							let resSetFileStorage = await setFileStorage(
								"fsuu_dsac_survey_sk",
								"form_list",
								dataSurveyFiltered,
							);

							if (resSetFileStorage && resSetFileStorage.uri) {
								setTimeout(() => {
									if (datasync) {
										datasync.classList.add("hide");
									}
								}, 1000);
							}
						}
					}
				}

				setIsLoading(false);
			}
		},
		false,
	);

	useEffect(() => {
		refetchFormList();

		const handleFocus = () => refetchFormList();
		window.addEventListener("focus", handleFocus);

		return () => window.removeEventListener("focus", handleFocus);
	}, [location.pathname, refetchFormList]);

	useEffect(() => {
		const isMissingFileError = (error) => {
			const errorMessage = (
				error?.message ||
				error?.toString?.() ||
				""
			).toLowerCase();
			return (
				errorMessage.includes("file does not exist") ||
				errorMessage.includes("not found")
			);
		};

		const handleReadFile = async () => {
			try {
				let resCheckPermissions = await checkPermissions();

				if (resCheckPermissions?.publicStorage === "granted") {
					try {
						let resReadFile = await readFile(
							"fsuu_dsac_survey_sk/form_list.txt",
						);

						if (resReadFile && resReadFile.data) {
							resReadFile = JSON.parse(resReadFile.data);
							setFormList(resReadFile);
						}
					} catch (err1) {
						if (!isMissingFileError(err1)) {
							console.error("Error reading form_list.txt: ", err1);
						}
					}

					try {
						let resReadFilePending = await readFile(
							"fsuu_dsac_survey_sk/survey_pending_list.txt",
						);

						console.log("resReadFilePending: ", resReadFilePending);

						if (resReadFilePending && resReadFilePending.data) {
							resReadFilePending = JSON.parse(resReadFilePending.data);
							setSurveyPendingList(resReadFilePending);
						}
					} catch (err2) {
						if (isMissingFileError(err2)) {
							setSurveyPendingList([]);
							await setFileStorage(
								"fsuu_dsac_survey_sk",
								"survey_pending_list",
								[],
							);
						} else {
							console.error("Error reading survey_pending_list.txt: ", err2);
						}
					}
				}
			} catch (err) {
				console.error("Error checking permissions or reading files: ", err);
			}
		};

		handleReadFile();

		return () => {};
	}, []);

	return (
		<Card>
			<Row>
				<Col xs={24} sm={24} md={24} lg={24} xl={24}>
					<Carousel className="intro" adaptiveHeight arrows>
						<div className="carousel-item-home">
							<img
								src={
									[
										"https://mob-survey.fsuuidea.com",
										"http://localhost:4004",
									].includes(host)
										? carouselImgLgu
										: carouselImgOrgon
								}
								alt="logo"
								loading="lazy"
								style={{ maxHeight: "400px", objectFit: "fill" }}
							/>
						</div>
					</Carousel>
				</Col>

				<Col xs={24} sm={24} md={24} lg={24} xl={24}>
					<Card
						className="survey-list-wrapper"
						title={
							<>
								<div className="title">
									{isLoading && (
										<FontAwesomeIcon
											icon={faSpinnerScale}
											style={{ color: "#2d60e2", marginRight: "8px" }}
											spin={isLoading}
										/>
									)}
									SURVEY LIST{" "}
								</div>
								<div className="action cursor-pointer">
									{surveyPendingList.length > 0 ? (
										<Badge
											count={surveyPendingList ? surveyPendingList.length : 0}
											overflowCount={99}
											onClick={() => navigate("/survey/pending")}
										>
											<FontAwesomeIcon
												icon={faSquare}
												style={{
													color: "#2d60e2",
												}}
											/>
										</Badge>
									) : null}
								</div>
							</>
						}
					>
						<SurveyList formList={formList} />
					</Card>
				</Col>
			</Row>
		</Card>
	);
}
